export const DEFAULT_IMAGE_POSITION = Object.freeze({
    top: 0,
    left: 0,
    scale: 1,
});

export const parseImagePosition = (value) => {
    if (!value || typeof value !== 'string') {
        return { ...DEFAULT_IMAGE_POSITION };
    }

    const parsed = { ...DEFAULT_IMAGE_POSITION };

    value.split(/[,;]/).forEach((part) => {
        const [rawKey, rawValue] = part.split(':').map((item) => item?.trim());
        if (!rawKey || !rawValue) return;

        const numericValue = Number.parseFloat(rawValue);
        if (!Number.isFinite(numericValue)) return;

        if (rawKey === 'top' || rawKey === 'left') {
            parsed[rawKey] = numericValue;
        }
        if (rawKey === 'scale') {
            parsed.scale = Math.max(0.5, Math.min(3, numericValue));
        }
    });

    return parsed;
};

export const serializeImagePosition = (position = DEFAULT_IMAGE_POSITION) => (
    `top: ${Number(position.top) || 0}px, left: ${Number(position.left) || 0}px, scale: ${Number(position.scale) || 1}`
);

export const getResponsiveImageVariables = (desktopValue, mobileValue, desktopOverride, mobileOverride) => {
    const desktop = desktopOverride || parseImagePosition(desktopValue);
    const mobile = mobileOverride || parseImagePosition(mobileValue || desktopValue);

    return {
        '--image-desktop-top': `${desktop.top}px`,
        '--image-desktop-left': `${desktop.left}px`,
        '--image-desktop-scale': desktop.scale,
        '--image-mobile-top': `${mobile.top}px`,
        '--image-mobile-left': `${mobile.left}px`,
        '--image-mobile-scale': mobile.scale,
    };
};
